import React, {Component} from 'react'
import Iframe from 'react-iframe'
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {authenticationService} from "../../services/AuthenticationService";
import patientApi from "../../services/ApiServices/patientApi";
import {history} from "../../utils/history";
import AlertConfirm from "../modals/Confirm";


class LeumitPaymentConnected extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }


    async goBackToOnboarding(RequestID) {
        let {t} = this.props
        let payment = await patientApi.checkIfPayed(RequestID)
        payment = payment ? payment.data : null
        if (!payment.payment) {
            let confirm = await AlertConfirm({
                options: {
                    title: '',
                }
            }, 'תתחיל בקשה חדשה ?')
            if (confirm) {
                history.push({
                    pathname: `/pain_patient_self_onboard`,
                    state: {
                        completed: false,
                        from: {
                            fromPath: `/national_pain_management_RequestPayment`,
                        }
                    },
                })
            }

        }
    }

    async finishProcess(RequestID) {
        setTimeout(async function () {
            let payment = await patientApi.checkIfPayed(RequestID)
            payment = payment ? payment.data : null
            if (payment.payment) {
                history.push({
                    pathname: `/national_pain_management_Request_Sent`,
                    state: {
                        from: {
                            fromPath: `/national_pain_management_RequestPayment`,
                        }
                    },
                })
            } else {
                let confirm = await AlertConfirm({
                    cancelLabel: 'none',
                    proceedLabel: 'Ok',
                    options: {
                        title: '',
                    }
                }, 'לא התקבל תשלום')
            }
        }, 1000);
    }


    render() {
        let {t} = this.props
        let entry = this.props.entry

        let programmPay = entry.toPay ? entry.toPay : 0

        let terminal = "asayatest"

        if (process.env.REACT_APP_ENV !== 'production') {
            if (parseInt(programmPay) > 0) {
                programmPay = parseInt(programmPay) / 10
            }
        } else {
            terminal = "asaya"
        }

        let tranzilaLang = "lang=il&"
        if (localStorage.getItem('language') === "en") {
            tranzilaLang = ""
        }



        let pdesc = entry.choose_programm
        pdesc = pdesc === "new" ? "הוצאת רישיון חדש" : pdesc
        pdesc = pdesc === "renew" ? "חידוש רישיון למטופלים קיימים" : pdesc
        pdesc = pdesc === "renew2" ? "חידוש רישיון למטופלים חדשים" : pdesc
        pdesc = pdesc === "newPrescription" ? "הוצאת מרשם חדש"  : pdesc
        pdesc = pdesc === "renewPrescription" ? "חידוש מרשם למטופלים קיימים" : pdesc
        pdesc = pdesc === "renew2Prescription" ? "חידוש מרשם למטופלים חדשים" : pdesc
        let email = entry.Additional_Email && entry.Additional_Email.length > 0 ? entry.Additional_Email : entry.Email

        let patientName = entry.First_name + " " + entry.Last_name
        let invoiceName = entry.InvoicingName && entry.InvoicingName.length > 0 ? entry.InvoicingName : patientName
        let tokenAuth = this.props.entry.tranzilaToken?this.props.entry.tranzilaToken:""

        tokenAuth = tokenAuth.replaceAll("_", "underscore")
        tokenAuth = tokenAuth.replaceAll("-", "score")
        tokenAuth = tokenAuth.replaceAll("=", "equals")
        tokenAuth = tokenAuth.replaceAll("+", "plus")
        tokenAuth = tokenAuth.replaceAll(".", "point")
        let token = tokenAuth.substring(0, 170)
        let tokenSecret = tokenAuth.substring(170)

        let urlForm ="https://direct.tranzila.com/" + terminal + "/iframenew.php?" + tranzilaLang + "sum=" + programmPay +
            "&currency=1&cred_type=1&PatientID=" + entry.UserStorageID + "&RequestID=" + entry.RequestID +
            "&token=" + token + "&tokenSecret=" + tokenSecret + "&pdesc=" + pdesc + "&email=" + email + "&contact=" + invoiceName +
            "&patientName=" + patientName+"&DCdisable=" + entry.RequestID

        return (

            <div>

                <div className={'Tranzila-block'}>
                    <Iframe url={urlForm}
                            width="100%"
                            height="100%"
                            id="myId"
                            className="myClassname"
                            display="initial"
                            position="relative"/>
                </div>

                <div className={'backBox'}>
                      <div className={'backBoxRighting'} onClick={() =>this.props.changeView(5)}>
                        {t('patient_self_boarding.back')}
                    </div>

                    <div className='selfSendRequestButton' onClick={() => this.finishProcess(entry.RequestID)}>
                        {t('patient_self_boarding.sendRequest')}
                    </div>

                </div>

            </div>


        )
    }
}


const LeumitPayment = compose(
    withTranslation(),
    connect(
        /*        mapStateToProps,
                mapDispatchToProps*/
    )
)(LeumitPaymentConnected)

export default LeumitPayment;
